export const stateFilter = [
  "match",
  ["get", "STATE"],
  ["AR", "IA", "IL", "IN", "LA", "MO", "MS", "OH"],
  true,
  false,
];

export const stateCode = {
  Arkansas: "AR",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Louisiana: "LA",
  Mississippi: "MS",
  Missouri: "MO",
  Ohio: "OH"
};

export const safeLabels = {
  IA_ES: "Iowa Early Successional-Neotropical Birds",
  IA_GG: "Iowa Gaining Ground",
  IA_GR: "Iowa Grand River",
  IA_PR: "Iowa Pheasant Recovery",
  IA_QH: "Iowa Quail Habitat",
  IL_PH: "Illinois Pheasant Initiative",
  IL_QI: "Illinois Quail Initiative",
  IN_IB: "Indiana Bat",
  IN_HS: "Indiana Henslows Sparrow",
  IN_NB: "Indiana Northern Bobwhite Quail",
  IN_RP: "Indiana Ring-necked Pheasant",
  MO_QM: "Missouri Bobwhite Quail",
  MO_SE: "Missouri Sand Ecosystem",
  MS_BB: "Mississippi Black Bear",
  MS_BP: "Mississippi Black Belt Prairie",
  MS_BQ: "Mississippi Bobwhite Quail",
  OH_MH: "Ohio Pollinator and Monarch Habitat",
  OH_UH: "Ohio Upland Bird Habitat"
};

export const landCoverTypeLabels = {
  aquaculture: "Aquaculture Ponds",
  cropland: "Cropland",
  pasture: "Pasture",
  wetland: "Wetland",
};

export const priorityLabels = {
  winderosion: "Wind Erosion",
  watererosion: "Water Erosion",
  soilhealth: "Soil Health",
  excesswind: "Excess Wind",
  drought: "Drought",
  // watertemperature: "Water Temperature",
  flooding: "Flooding",
  snowdrift: "Snow Drift",
  waterquality: "Water Quality",
  aquatic: "Aquatic",
  biggame: "Big Game",
  grasslandbirds: "Grassland Birds",
  forestbirds: "Forest Birds",
  pollinators: "Pollinators",
  waterfowl: "Waterfowl",
  carbonstorage: "Carbon Storage",
  priorityecosystem: "Ecosystem",
};

export const safePractices = {
  IA_ES: "CP38 - IOWA HABITAT FOR EARLY SUCCESSIONAL & NEOTROPICAL MIGRATORY BIRDS SAFE",
  IA_GG: "CP38 - IOWA GAINING GROUND SAFE",
  IA_GR: "CP38 - IOWA GRAND RIVER GRASSLAND SAFE",
  IA_PR: "CP38 - IOWA PHEASANT RECOVER SAFE",
  IA_QH: "CP38 - IOWA QUAIL HABITAT SAFE",
  IL_PH: "CP38 - Illinois Pheasant Initiative SAFE",
  IL_QI: "CP38 - Illinois Quail Initiative SAFE",
  MO_QM: "CP38 - Missouri Bobwhite Quail and Monarch Butterfly Habitat Restoration SAFE",
  MO_SE: "CP38 - Missouri Sand Ecosystem Restoration SAFE",
  MS_BB: "CP38 - Mississippi Black Bear Habitat Restoration in the Mississippi Alluvial Valley SAFE",
  MS_BP: "CP38 - Mississippi, Alabama, Black Belt Prairie Restoration SAFE",
  MS_BQ: "CP38 - Mississippi Bobwhite Quail Habitat SAFE",
};

export const withinFloodplainPractices = ["CP23"];
export const outsideFloodplainPractices = ["CP23A"];

export const waterBufferPractices = {
  CP21: { min: 20, max: 120 },
  CP22: { min: 35, max: 100 },
  CP29: { min: 20, max: 120 },
  CP30: { min: 20, max: 120 },
  CP37: { min: null, max: null },
  CP39: { min: null, max: null },
  CP41: { min: 30, max: null },
};

export const crepColorPool = [
  "#8e44ad",
  "#e67e22",
  "#3498db",
  "#27ae60",
  "#e74c3c",
];

export const crepColorMap = new Map();

export const crepCodes = {
  "NORTH CENTRAL IOWA CREP": "DML",
  "ILLINOIS RIVER CREP": "ILC",
  "KASKASKIA RIVER CREP": "ILC",
  "INDIANA CREP": "INC",
  "MISSISSIPPI DELTA CREP": "MD",
  "LAKE ERIE CREP": "LEW",
  "SCIOTO RIVER CREP": "SRW"
};

export const pastureRateStates = ['OH', 'IL', 'IN'];
    
export const practiceNoteData = {
  CP8A: "Note: CP8A grass waterways must not exceed a maximum width of 100ft. Click Details for more information on CP8A.",
  CP9: "Note: CP9 practice enrollment must not exceed 10 acres. The buffer area must be a minimum width of 20ft and maximum width of 120ft. Click Details for more information on CP9.",
  CP12: "Note: CP12 must be enrolled in conjunction with another practice. Wildlife food plots must not exceed 5 acres. Click Details for more information on CP12.",
  CP15A: "Note: CP15A strip widths may vary between 15 and 60ft. Click Details for more information on CP15A.",
  CP15B: "Note: CP15B strip widths are generally 10ft wide. Click Details for more information on CP15B.",
  CP21: "Note: CP21 filter strips must be immediately adjacent to and parallel to an identified water body. Filter strips must be a minimum of 20ft and maximum of 120ft. Click Details for more information on CP21.",
  CP22: "Note: CP22 buffers must be immediately adjacent to and parallel to an identified water body. A riparian buffer must be a minimum of 35ft and maximum of 180 ft. For marginal pastureland enrolled in CP22, payment estimates will be based off the county Marginal Pastureland Rental Rate. Click Details for more information on CP22.",
  CP23: "Note: The CP23 buffer to wetland ratio must not exceed 3:1. Click Details for more information on CP23.",
  CP23A: "Note: The CP23A buffer to wetland ratio must not exceed 4:1. Click Details for more information on CP23A.",
  CP27: "Note: Land eligible for CP27 must be under 40 acres. Click Details for more information on CP40.",
  CP28: "Note: CP28 buffers must be a minimum of 30ft around a wetland and maximum of 4x the wetland size. Click Details for more information on CP28.",
  CP29: "Note: CP29 buffers must be immediately adjacent and parallel to an identified water body. A marginal pastureland wildlife buffer must be a minimum of 20ft and maximum of 120ft. Click Details for more information on CP29.",
  CP30: "Note: CP30 buffers must be immediately adjacent and parallel to an identified water body. A marginal pastureland wetland buffer must be a minimum of 20ft and maximum of 120ft. Click Details for more information on CP30.",
  CP33: "Note: CP33 buffers must be a minimum average of 30ft and maximum average of 120ft. Fields must be greater than 5 acres to be eligible for CP33. Click Details for more information on CP33.",
  CP37: "Note: CP37 practices must be located outside of the 100-year floodplain. The buffer to wetland ratio must be a minimum of 4:1 and maximum of 10:1. Click Details for more information on CP37.",
  CP39: "Note: CP39 practice site must not exceed 40 acres and buffer area must not exceed 4x the size of the wetland. Click Details for more information on CP39.",
  CP41: "Note: CP41 practice site must not exceed 40 acres, with a maximum of 20 acres of wetland. The buffer area must not exceed 4x the size of the wetland. Click Details for more information on CP41.",
  CP42: "Note: CP42 maximum enrollment is 10 acres and strips must be a minimum of 20ft wide. Click Details for more information on CP42.",
  CP43: "Note: CP43 strip must be a minimum of 30ft and a maximum of 120ft. Click Details for more information on CP43.",
};